import React from 'react';



const PlantsList = ( ) =>{

    
    return (

        <div id="About" className="App">
            <h1>About Watering the Plants</h1>
            <br />
            <p>
                <i>App Slogan...</i>
            </p>
            <p>
                Details
            </p>
            <h2>
                Features
            </h2>
            <ul>
                <li>
                    Just a listed detail
                </li>
                <li>
                    New Detail Listed.
                </li>
                <li>
                    Styled detail list
                </li>
            </ul>
        </div>
    );
}

export default PlantsList 